import fastSafeStringify from 'fast-safe-stringify';
const stringify = (val: unknown): string =>
  fastSafeStringify(val, undefined, 2);

export { stringify };
